<template>
  <div>
    <header class="mdc-top-app-bar top-app-bar top-header">
      <div class="mdc-top-app-bar__row">
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
        </section>
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
          <div class="t-body2 t-color-white pdr-18"></div>
        </section>
      </div>
    </header>
    <div class="d-flex h-full flex-column">
      <main class="main-wrapper full flex-grow-1 scroll-y">
        <div class="container container--small pdt-50 pdb-50">
          <form novalidate @submit.prevent="login">
            <div class="t-headline18 font-m mgt-20 pdb-18 t-center">{{ title }}</div>
            <div class="pdl-24 pdr-24">
              <div class="mgt-36">
                <label
                    id="userIdEl"
                    ref="userIdEl"
                    :class="submitState && userIdInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
                    data-mdc-auto-init="MDCTextField"
                >
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span id="my-label-id" class="mdc-floating-label">{{ $t('287') }}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
                  <input id="userId"
                         ref="userId"
                         v-model="userId"
                         v-validate="'required'"
                         autocomplete="off"
                         class="mdc-text-field__input"
                         maxlength="50"
                         name="userId"
                         type="email"

                  />
                  <i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" role="button"
                     tabindex="0">report_problem</i>
                </label>
                <div class="mdc-text-field-helper-line">
                  <div v-show="submitState && userIdInvalidCheck"
                       id="my-helper-id" aria-hidden="true"
                       class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r">
                    {{ $t('312') }}
                  </div>
                </div>
              </div>
              <div class="mgt-16">
                <label
                    id="passwordEl"
                    :class="submitState && passwordInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
                    data-mdc-auto-init="MDCTextField">
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span id="password-message" class="mdc-floating-label">{{ $t('288') }}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
                  <input id="password"
                         ref="password"
                         v-model="password"
                         v-validate="'required'"
                         aria-labelledby="password-message"
                         class="mdc-text-field__input"
                         name="password"
                         type="password"
                  />
                  <i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" role="button"
                     tabindex="0">report_problem</i>
                </label>
                <div class="mdc-text-field-helper-line">
                  <div v-show="submitState && passwordInvalidCheck"
                       id="my-helper-id" aria-hidden="true"
                       class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r">
                    {{ $t('107') }}
                  </div>
                </div>
              </div>
              <div class="mgt-30">
                <button
                    class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full b-radius4 mgb-16 loginBtn">
                  <div class="mdc-button__ripple"></div>
                  <span class="mdc-button__label t-body2 font-r">{{ $t('289') }}</span>
                </button>
              </div>
            </div>

            <div class="pdt-14 pdl-16">
              <div class="mdc-form-field" @keypress="focusActive()">
                <div class="mdc-checkbox">
                  <input id="checkbox-1" v-model="remember"
                         class="mdc-checkbox__native-control"
                         type="checkbox"
                  />
                  <div class="mdc-checkbox__background check-red" tabindex="0">
                    <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                      <path class="mdc-checkbox__checkmark-path" d="M1.73,12.91 8.1,19.28 22.79,4.59"
                            fill="none"/>
                    </svg>
                    <div class="mdc-checkbox__mixedmark"></div>
                  </div>
                  <!-- 	<div class="mdc-checkbox__ripple"></div> -->
                </div>
                <label id="radioBtn" class="pdb-2 t-color-bodyGrayA font-r t-body4 pdl-0 pdr-12"
                       for="checkbox-1">{{ $t('1921') }}</label>
              </div>
            </div>
            <div class="pdt-16 pdl-24 pdr-24 pdb-24">
              <div class="">
                <router-link class="t-body3 font-r t-color-signBlue" tabindex="0" to="/findid"> {{ $t('291') }}
                </router-link>
                <span class="t-body3 font-r t-color-signGray pdl-4 pdr-4">{{ $t('292') }}</span>
                <router-link class="t-body3 font-r t-color-signBlue" tabindex="0" to="/findpw">{{ $t('293') }}
                </router-link>
              </div>
              <div class="mgt-17">
                <span class="t-body3 font-r t-color-signGray pdr-4">{{ $t('294') }}</span>
                <router-link class="t-body3 font-r t-color-signRed" tabindex="0" to="/join2">{{ $t('299') }}
                </router-link>
              </div>
              <div class="mgt-16">
                <div class="t-body3 font-r t-color-signGray pdr-4" v-html="$t('295')"></div>
                <div class="">
                  <router-link class="t-body3 font-r t-color-signBlue" tabindex="0" to="/terms">{{ $t('296') }}
                  </router-link>
                  <span class="t-body3 font-r t-color-signGray pdl-4 pdr-4">{{ $t('297') }}</span>
                  <router-link class="t-body3 font-r t-color-signBlue" tabindex="0" to="/privacy">{{ $t('298') }}
                  </router-link>
                </div>
              </div>
            </div>

        <!-- KAKAO CHANNEL LINK -->
        <div class="mgt-20 t-body3 kakao-wrapper t-center">
          <div class="t-color-signGray">
            {{ $t('4015') }}
          </div>
          <div class="t-color-signGray">
            {{ $t('4016') }}
          </div>
          <div class="mgb-44 t-body3 t-color-signBlue cursor-pointer" @click="openKakao">
              {{ $t('4017') }}
          </div>
        </div>

            <div v-if="socialAuth === true" class="divider mgl-24 mgr-24"></div>

            <!-- <div class="pdt-24" v-if="socialAuth===true"> -->
            <div v-if="socialAuth === true" class="pdt-40">
              <div class=" t-body4 t-color-bodyGrayA l-spacing39 t-nowrap t-center mgb-20">{{ $t('3451') }}</div>
              <div class="d-flex align-items-center justify-content-center flex-column">
                <button v-if="isActivePlatform(platform.google)"
                        class="mdc-button btn-sns-sign point-mark social-button bg-google"
                        tabindex="0" @click.prevent="socialLoginAuth('google')" @keypress.prevent="socialLoginAuth('google')">
                  <img alt="google" src="../assets/google.svg"> <span
                    class="pdl-12 t-body1 t-color-white t-capitalize l-spacing0">{{ $t('3463') }}</span>
                </button>
                <button v-if="isActivePlatform(platform.facebook)"
                        class="mdc-button btn-sns-sign point-mark facebook social-button"
                        tabindex="0" @click.prevent="socialLoginAuth('facebook')" @keypress.prevent="socialLoginAuth('facebook')">
                  <img alt="facebook" src="../assets/facebook.svg"> <span
                    class="pdl-12 t-body1 t-color-white t-capitalize l-spacing0">{{ $t('3464') }}</span>
                </button>

                  <vue-telegram-login v-if="isActivePlatform(platform.telegram)" :telegram-login="bot" mode="callback" @callback="telegramCallbackFunction" tabindex="0" class="b-radius20 mdc-button btn-sns-sign point-mark telegram social-button p-0"/>

                <button v-if="isActivePlatform(platform.naver)"
                        class="mdc-button btn-sns-sign point-mark social-button bg-naver l-spacing0"
                        tabindex="0" @click.prevent="clickNaver" @keypress.prevent="clickNaver">
                  <img alt="naver" src="../assets/naver.svg"> <span class="pdl-12 t-body1 t-capitalize t-color-white ">{{
                    $t('3465')
                  }}</span>
                </button>
                <button v-if="isActivePlatform(platform.apple)"
                        class="mdc-button btn-sns-sign social-button bg-apple l-spacing0"
                        tabindex="0" @click.prevent="socialLoginAuth('apple')" @keypress.prevent="socialLoginAuth('apple')">
                  <img alt="apple" src="../assets/apple.svg"> <span
                    class="pdl-12 t-body1 t-capitalize t-color-white">{{ $t('3466') }}</span>
                </button>
              </div>
              <div v-if="isActivePlatform(platform.naver)" id="naver_id_login"
                   class="naver-wrapper social-button bg-naver"></div>
            </div>
          </form>
        </div>
      </main>
    </div>
    <router-view></router-view>
  </div>

</template>

<script>
/**
 * 로그인 컴포넌트(sign in main component)
 *
 * @author minkyoung.park@emcast.com
 */

import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import loginApi from '@/api/loginApi.js'
import brandApi from '@/api/brandApi.js'
import popupApi from '@/api/popupApi.js'
import joinApi from '@/api/joinApi.js'
import firebase from 'firebase'

import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'

import {setLocaleLanguage} from '@/translations/i18nSetup'
import {mapState, mapMutations} from 'vuex'
import {commonMixin} from "@/mixins/common.js";
import {vueTelegramLogin} from 'vue-telegram-login'
import {storageConstants} from '@/utils/enum/StorageConstants';
import i18nApi from "@/api/i18nApi";
import localStorageUtil from "@/utils/localStorageUtil";
import { userMixin } from "@/mixins/user";

export default {
  name: 'signin',

  components: {
    TopAppBar, vueTelegramLogin
  },

  mixins: [topAppBarMixin, commonMixin, userMixin],

  data() {
    return {
      userId: localStorage.getItem(storageConstants.rememberUser) || null,
      password: '',
      socialType: '',
      socialToken: '',
      platform: {
        google: 'GOOGLE',
        facebook: 'FACEBOOK',
        telegram: 'TELEGRAM',
        apple: 'APPLE',
        naver: 'NAVER'
      },
      rPath: '',
      pathName: null,
      stateLogin: false,
      submitState: false,
      userIdTextField: null,
      passwordTextField: null,
      redirectPath: '',
      snackbar: null,
      //brandLogo: localStorage.brandLogo,
      socialFirstName: '',
      socialLastName: '',
      socialFullName: '',
      socialEmail: '',
      socialAuth: false,
      socialCode: '',
      title: null,
      bradName: localStorage.getItem('brandName'),
      popupData: null,
      popupImage: null,
      remember: localStorage.getItem(storageConstants.rememberUser) ? true : false,
      device_type: null,
      socialLoginLanguage: JSON.parse(localStorage.getItem('languageInfo')).code,
      naverAcessTooken: '',
      bot: localStorage.getItem('TELEGRAM_BOT')
    }
  },
  computed: {
    isTabType() {
      return this.tabType
    },

    // UserId validation check
    userIdInvalidCheck() {
      let returnValue = false
      if (this.submitState) {
        if (this.errors.has('userId')) {
          returnValue = true
        } else {
          returnValue = false
        }
      }
      this.userIdTextField.valid === !returnValue ? '' : this.userIdTextField.valid = !returnValue
      return returnValue
    },

    // password validation check
    passwordInvalidCheck() {
      let returnValue = false
      if (this.submitState) {
        if (this.errors.has('password')) {
          returnValue = true
        } else {
          returnValue = false
        }
      }
      this.passwordTextField.valid === !returnValue ? '' : this.passwordTextField.valid = !returnValue
      return returnValue
    },
  },

  created() {
    // Redirect URL
    this.title = localStorage.getItem('brandName') || this.$t('286')
    this.device_type = localStorage.getItem("deviceOS") === "undefined"
        ? "WEB" : localStorage.getItem("deviceOS");
    this.socialCode = JSON.parse(localStorage.getItem("SOCIAL_CODE"));

    i18nApi.guestBrands().then((response) => {
      let brands = response.data.data;
      this.pathName = brands.length < 2 ? "Login" : "BrandSelect";
    }).catch((err) => {
      this.$router.push('/error')
    })
  },

  mounted() {
    // script js code
    this.setMaterialUi()
    // 브랜드 설정 소셜 로그인 사용 여부 확인(Check social login is enabled)
    brandApi.brandInfo().then((response) => {
      const { data } = response.data;
      const { socialAuth, social, name, authUrl, idp } = data;

      this.socialAuth = socialAuth;
      this.socialCode = social;
      document.title = name;
      localStorage.setItem("browserTitle", name);

      if(idp) {
        localStorage.setItem(storageConstants.idpService, idp);
        window.location = localStorageUtil.getIdpUrl();
      } else {
        localStorage.removeItem(storageConstants.idpService);
      }
    })

    setTimeout(() => {
      if (this.socialAuth == true && this.socialCode[3].active) {
        const fullPath = location.protocol + '//' + location.host
        const naver_id_login = new window.naver_id_login(localStorage.getItem('NAVER_KEY'), `${fullPath}/login`);
        const state = naver_id_login.getUniqState();
        naver_id_login.setState(state);
        naver_id_login.setButton("", "", 45);
        naver_id_login.init_naver_id_login();
        naver_id_login.get_naver_userprofile();
        this.naverAcessTooken = naver_id_login.getAccessToken()
        if (this.naverAcessTooken) {
          this.$showLoading();
          setTimeout(() => {
            this.getUserDetails()
          }, 2000)

        }

      }
    }, 1000)
  },

  methods: {
    focusActive() {
      let toActive = document.querySelector('.mdc-checkbox__background');
      toActive.classList.toggle('radio-active');
    },
    // Store Mutations define
    ...mapMutations('join', [
      'SET_JOINSTART', 'SET_SOCIAL_LINK', 'SET_PUSH_NOTIFICATION', 'SET_NAME_FIRST', 'SET_NAME_LAST', 'SET_NAME_FULL', 'SET_LOGINID', 'SET_SOCIAL_ID', 'INIT_JOIN_STORE'
    ]),

    ...mapMutations("dormancy", [
      "MUTATION_USER_DATA"
    ]),


    isActivePlatform(platform) {
      return this.socialCode.find(value => value.platform.name === platform).active;
    },

    setMaterialUi() {
      this.userIdTextField = new MDCTextField(document.getElementById('userIdEl'))
      this.passwordTextField = new MDCTextField(document.getElementById('passwordEl'))

      // 자동 유효성 체크 제거(Automatic Validation Remove)
      this.userIdTextField.useNativeValidation = false
      this.passwordTextField.useNativeValidation = false

    },

    /*************************** Naver Signup *********************************/
    clickNaver() {
      document.getElementById('naver_id_login_anchor').click()
    },
    getUserDetails() {
      const fullPath = location.protocol + '//' + location.host
      let naver_id_login = new window.naver_id_login(localStorage.getItem('NAVER_KEY'), `${fullPath}/login`);
      const state = naver_id_login.getUniqState();
      naver_id_login.getAccessToken();
      naver_id_login.get_naver_userprofile();
      this.socialFirstName = naver_id_login.getProfileData('name')
      this.socialLastName = ''
      this.socialFullName = naver_id_login.getProfileData('name')
      this.socialEmail = naver_id_login.getProfileData('email')

      let params = {
        "uid": this.socialEmail,
        "name": "naver",
        "type": "naver",
        "email": this.socialEmail
      }

      joinApi.customToken(params).then((response) => {
        firebase.auth().signInWithCustomToken(response.data.data).then((result) => {
          firebase.auth().currentUser.getIdToken().then((idToken) => {
            this.$hideLoading();
            this.socialToken = idToken
            this.socialType = "naver"
            this.login('social')
          }).catch((error) => {
            console.log('getIdToken=>error', error)
          })
        }).catch((error) => {
          console.log('signInWithCustomToken=>error', error)
        })
      }).catch((error) => {
        console.log('customToken=>error', error)
      })

    },

    /********************************** End Here *****************************/

    /****************************** Telegram signup ***************************/

    telegramCallbackFunction(user) {
      this.$showLoading();

      this.socialFirstName = user.first_name
      this.socialLastName = ''
      this.socialFullName = user.first_name
      this.socialEmail = user.id

      let params = {
        "uid": user.id,
        "name": "telegram",
        "type": "telegram",
        "email": ""
      }
      // get custom token
      joinApi.customToken(params).then((response) => {
        firebase.auth().signInWithCustomToken(response.data.data).then((result) => {
          firebase.auth().currentUser.getIdToken().then((idToken) => {
            this.$hideLoading();
            this.socialToken = idToken
            this.socialType = "telegram"
            this.login('social')
          }).catch((error) => {
            console.log('getIdToken=>error', error)
          })
        }).catch((error) => {
          console.log('signInWithCustomToken=>error', error)
        })
        this.$hideLoading();
      }).catch((error) => {
        console.log('customToken=>error', error)
      })
      //return
    },

    /****************************** Telegram End ************************************/

    // set parameter
    setParams(loginType) {
      let params = null

      if (loginType === 'social') {
        params = {
          userId: '',
          password: '',
          device: {
            type: 'WEB'
          },
          social: {
            type: 'firebase',
            token: this.socialToken
          }
        }
      } else {
        params = {
          userId: this.userId,
          password: this.password,
          device: {
            type: 'WEB'
          }
        }

      }
      return params
    },

    // click login button
    login(loginType) {
      if (loginType === 'social') {
        this.callLoginApi(loginType)
      } else {
        this.$validator.validateAll().then((resultValid) => {
          this.submitState = true
          if (resultValid) {
            this.callLoginApi(loginType)
          } else {
            this.focusFirstInvalidElement()
          }
        })
      }
    },

    callLoginApi(loginType) {
      let params = this.setParams(loginType)
	    
      loginApi.login(params).then((response) => {
        this.checkRememberStatus();
        let responseData = response.data.data
        localStorage.setItem("userParams", JSON.stringify(params))
        loginApi.setAuthInHeader(responseData.token)
        this.MUTATION_USER_DATA(responseData);
        // 휴면해제 회원 라우팅
        if (responseData.dormancy) {
          return this.checkUser()
        }
        if (responseData.token) {
          loginApi.fetchMember().then(response => {
            let mamberData = response.data.data;
            let fullNames = mamberData ? mamberData.name.fullName : "";
            let firstCharOfName = fullNames.slice(0, 1);
            localStorage.setItem('firstChar', firstCharOfName)
            let colors = ['#fb6262', '#d16443d4', '#4d9fd6', '#40bca7', '#9db82f', '#76a0d6', '#a967d4', '#696481', '#4c438d', '#fe7947'];
            let randomColor = colors[Math.floor(Math.random() * colors.length)];
            localStorage.setItem('bgColors', `background-color:${randomColor}`)
	          //Todo 로그인 성공 후 체크 로직 : 휴면, 약관동의, 6개월 비밀번호 변경, 직무직책
            this.checkUser();
          }).catch(err => {
            $state.error();
          });
        }
	      
      }).catch((err) => {
        console.log(err)
        const responseData = err.response.data.meta

        if (responseData.errCode === 1200) {    //관리자 승인 대기중(Waiting for administrator approval)
          // 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
          //this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

          if (loginType === 'social') {   //소셜 로그인 정보 없을 때(No social login information)
            this.$confirm({
              title: this.$t('300'),//'잘못된 로그인 정보' ,
              content: this.$t('301'), //'가입된 SNS 계정이 아닙니다. 이 SNS 계정으로 회원 가입하시겠습니까?'
              accept: this.$t('304'),
              cancel: this.$t('303')
            }).then(() => {
              this.SET_JOINSTART(true)
              this.SET_NAME_FIRST(this.socialFirstName)
              this.SET_NAME_LAST(this.socialLastName)
              this.SET_NAME_FULL(this.socialFullName)
              this.SET_SOCIAL_LINK({
                type: 'firebase',
                name: this.socialType.toUpperCase(),
                token: this.socialToken,
                socialType: loginType,
                userloginLanguage: this.socialLoginLanguage
              })

              this.SET_PUSH_NOTIFICATION({
                pushToken: '',
                pushLanguage: this.userloginLanguage,
                // notificationed: false
              })

              this.SET_SOCIAL_ID(this.socialEmail)
              this.SET_LOGINID(this.socialEmail)
              this.$router.push({
                name: 'Join2Policy', query: {
                  type: 'social'
                }
              })

            }).catch(() => {
              this.signOutFirebase()
            })
          } else {
            // this.$snackOpen({contents:'올바르지 않은 로그인 정보입니다.'}).then(() => {})
            this.$snackOpen({contents: this.$t('356'), btnDisplay: this.$t('357')}).then(() => {
            })
          }

        } else if (responseData.errCode === 1201) {    //관리자 승인 대기중(Waiting for administrator approval)
          // 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
          //this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

          this.$alert({
            title: this.$t('779'), //가입 승인 대기 상태입니다.
            content: this.$t('780') + '<br>' + this.$t('781', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>'}) + '<br>' + this.$t('782', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>'}),
            accept: this.$t('783')
          }).then(() => {
          }).catch(() => {
          })

        } else if (responseData.errCode === 1202) {
          this.$alert({
            title: this.$t('779'), //가입 승인 대기 상태입니다.
            content: this.$t('780') + '<br>' + this.$t('781', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>'}) + '<br>' + this.$t('782', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>'}),
            accept: this.$t('783')
          }).then(() => {
          }).catch(() => {
          })
        } else if (responseData.errCode === 1204) {
          this.$alert({
            title: this.$t('1482'), //가입 승인 대기 상태입니다.
            content: this.$t('1483') + '<br>' + this.$t('1484') + ': ' + '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>' + '<br>' + this.$t('1485') + ': ' + '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>',
            accept: this.$t('1486')
          }).then(() => {
          }).catch(() => {
          })
        } else if (responseData.errCode === 1205) {
          this.$alert({
            title: this.$t('1914'), //가입 승인 대기 상태입니다.
            content: this.$t('1915') + " " + this.$t('1916') + '<br>' + this.$t('1917', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>'}) + '<br>' + this.$t('1918', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>'}),
            accept: this.$t('1919')
          }).then(() => {
          }).catch(() => {
          })
        } else if (responseData.errCode === 1206) {
          this.$alert({
            title: this.$t("3866"),
            content: `${this.$t("3867")} <br /> ${this.$t("3868", {str: `<a href="mailto: ${BRAND_MANAGER_EMAIL}">${BRAND_MANAGER_EMAIL}</a>`})} <br /> ${this.$t("3869", {str: `<a href="tel: ${BRAND_MANAGER_PHONE}">${BRAND_MANAGER_PHONE}</a>`})}`,
            accept: this.$t('3870')
          })
        } else if (responseData.errCode === 1207) {
          this.$alert({
            title: this.$t("3871"),
            content: `${this.$t("3872")} <br /> ${this.$t("3873", {str: `<a href="mailto: ${BRAND_MANAGER_EMAIL}">${BRAND_MANAGER_EMAIL}</a>`})} <br /> ${this.$t("3874", {str: `<a href="tel: ${BRAND_MANAGER_PHONE}">${BRAND_MANAGER_PHONE}</a>`})}`,
            accept: this.$t('3875')
          })
        } else if (responseData.errCode === 1105) {
          this.$alert({
            content: this.$t('1875'),
            accept: this.$t('1876')
          }).then(() => {
          }).catch(() => {
          })
        } else if (responseData.errCode === 1335) {  //아이디 계정 일시 정지(Suspend Account)
          // 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
          this.$snackOpen({contents: this.$t('323'), btnDisplayYN: false}).then(() => {
          })
        } else {
          if (loginType === 'social') {   //소셜 로그인 정보 없을 때(No social login information)
            this.$confirm({
              title: this.$t('300'),//'잘못된 로그인 정보' ,
              content: this.$t('301'), //'가입된 SNS 계정이 아닙니다. 이 SNS 계정으로 회원 가입하시겠습니까?'
              accept: this.$t('304'),
              cancel: this.$t('303')
            }).then(() => {
              this.SET_JOINSTART(true)
              this.SET_NAME_FIRST(this.socialFirstName)
              this.SET_NAME_LAST(this.socialLastName)
              this.SET_NAME_FULL(this.socialFullName)
              this.SET_SOCIAL_LINK({
                type: 'firebase',
                name: this.socialType.toUpperCase(),
                token: this.socialToken,
                socialType: loginType,
                userloginLanguage: this.socialLoginLanguage

              })

              this.SET_PUSH_NOTIFICATION({
                pushToken: '',
                pushLanguage: this.userloginLanguage,
                // notificationed: false
              })

              this.SET_SOCIAL_ID(this.socialEmail)
              this.SET_LOGINID(this.socialEmail)
              this.$router.push({
                name: 'Join2Policy', query: {
                  type: 'social',
                }
              })

            }).catch(() => {
              this.signOutFirebase()
            })
          } else {
            // this.$snackOpen({contents:'올바르지 않은 로그인 정보입니다.'}).then(() => {})
            this.$snackOpen({contents: this.$t('356'), btnDisplayYN: true, btnDisplay: this.$t('357')}).then(() => {
            })
          }
        }
      })
    },

    signOutFirebase() {
      firebase.auth().signOut()
    },

    socialLoginAuth(socialType) {
      let provider = null
      this.socialType = socialType

      if (socialType === 'google') {
        provider = new firebase.auth.GoogleAuthProvider()
      } else if (socialType === 'facebook') {
        provider = new firebase.auth.FacebookAuthProvider()
      } else if (socialType === 'apple') {
        provider = new firebase.auth.OAuthProvider('apple.com');
        provider.addScope('email');
        provider.addScope('name');
      }

      firebase.auth().signInWithPopup(provider).then((result) => {
        let providerUserInfo = null
        providerUserInfo = result.additionalUserInfo.profile
        if (socialType === 'google') {
          this.socialFullName = providerUserInfo.name
          this.socialEmail = providerUserInfo.email
          if (providerUserInfo.locale && providerUserInfo.locale.toLowerCase() == 'ko') {
            if (socialType == 'google' && JSON.parse(localStorage.getItem('languageInfo')).code.toLowerCase() == 'en') {
              this.socialFirstName = providerUserInfo.given_name
              this.socialLastName = providerUserInfo.family_name
            } else {
              this.socialLastName = providerUserInfo.family_name
              this.socialFirstName = providerUserInfo.given_name
            }

          } else {
            this.socialFirstName = providerUserInfo.family_name
            this.socialLastName = providerUserInfo.given_name
          }
        } else if (socialType === 'facebook') {
          this.socialFirstName = providerUserInfo.first_name
          this.socialLastName = providerUserInfo.last_name
          this.socialFullName = providerUserInfo.name
          this.socialEmail = providerUserInfo.email
        } else if (socialType === 'apple') {

          let displayNames = result.user.displayName
          if (displayNames) {
            let split_name = displayNames.split(' ')
            this.socialFirstName = split_name[0]
            this.socialLastName = split_name[1]
            this.socialFullName = displayNames
          } else {
            this.socialFirstName = ''
            this.socialLastName = ''
            this.socialFullName = ''
          }

          this.socialEmail = result.user.email
        }

        firebase.auth().currentUser.getIdToken(true).then((idToken) => {
          this.socialToken = idToken
          this.login('social')

        }).catch((error) => {
          console.log('error1', error)
        })

      }).catch((error) => {
        console.log("SOCIAL LOGIN ERROR : ", error);
        if (error.email && error.credential && error.code === 'auth/account-exists-with-different-credential') {
          let params = {
            title: '',
            content: error.message,
            accept: this.$t('833')
          }
          this.$confirm(params).then(() => {
            firebase.auth().signOut()
          }).catch(() => {
            firebase.auth().signOut()
            //this.$moveLogin()
          })
        }
      })
    },

    focusFirstInvalidElement() {
      let invalidElementName = Object.keys(this.errors.collect())[0]
      this.$refs[`${invalidElementName}`].focus()
    },
    checkRememberStatus() {
      // check if remember status is true
      if (this.remember) {
        // save user-id into localstorage
        localStorage.setItem(storageConstants.rememberUser, this.userId.trim());
      } else {
        localStorage.removeItem(storageConstants.rememberUser);
      }
    },

    openKakao() {
      window.open(process.env.VUE_APP_KAKAO_CHANNEL_LINK, "noopener noreferrer");
    }
  }
}
</script>
<style scoped>
#naver_id_login {
  visibility: hidden;
}

/* .mdc-form-field > label {
  padding-left: 2px;
} */
/* div#naver_id_login {
    border-radius: 50% !important;
    margin-left: 4px !important;
    overflow: hidden;
} */
.kakao-wrapper {
  display: flex;
  justify-content: center; 
  align-items: center; 
  flex-direction: column;
}
</style>
